import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import RecallDetailsView from '../views/recall-details';
import { loadRecallDetails, onRecallTagSelect } from '../actions';
import { getLocale } from '../selectors';
import * as selectors from '../selectors';

export default connect(
  state => ({
    recall: get(state, 'recallDetails.data', {}),
    error: get(state, 'recallDetails.error'),
    isFething: get(state, 'recallDetails.isFething'),
    locale: getLocale(),
    config: selectors.getConfig(state),
  }),
  { loadRecallDetails, onRecallTagSelect }
)(RecallDetailsView);



// WEBPACK FOOTER //
// ./src/containers/recall-details.js